package com.iregained.site.components.sections.home.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val BenefitCardStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("transform", 0.3.s))
    }
    hover {
        Modifier.translateY((-8).px)
    }
}

val BenefitIconStyle = CssStyle {
    base {
        Modifier.transition(Transition.of("transform", 0.3.s), Transition.of("filter", 0.3.s))
    }
    hover {
        Modifier.scale(1.1)
            // Adds a soft drop shadow to the icon itself on hover
            .styleModifier { property("filter", "drop-shadow(0px 4px 6px rgba(0, 128, 128, 0.2))") }
    }
}